import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const mobileRequestToggleVariants = cva(
  'group inline-flex h-[33px] shrink-0 items-start gap-[-1px] rounded-allocated bg-white',
  {
    variants: {
      state: {
        open: '',
        exceedsThreshold: '',
        pause: '',
      },
    },
    defaultVariants: {
      state: 'open',
    },
  }
)

const openButtonVariants = cva('flex items-center justify-center self-stretch rounded-l-[6px] p-2', {
  variants: {
    state: {
      open: 'border border-green-700 bg-green-500',
      exceedsThreshold: 'border border-orange-800 bg-orange-400',
      pause:
        'border-b border-b-gray-600 bg-[linear-gradient(180deg,rgba(58,72,98,0.94)_0%,rgba(17,25,40,0.78)_5.21%,#010203_100%)] *:fill-gray-400',
    },
  },
  defaultVariants: {
    state: 'open',
  },
})

const closeButtonVariants = cva('flex items-center justify-center self-stretch rounded-r-[6px] p-2', {
  variants: {
    state: {
      open: 'border-b border-gray-600 bg-[linear-gradient(180deg,rgba(58,72,98,0.94)_0%,rgba(17,25,40,0.78)_5.21%,#010203_100%)] *:fill-gray-400',
      exceedsThreshold:
        'border-b border-gray-600 bg-[linear-gradient(180deg,rgba(58,72,98,0.94)_0%,rgba(17,25,40,0.78)_5.21%,#010203_100%)] *:fill-gray-400',
      pause: 'border border-red-500 bg-red-800 *:fill-white',
    },
  },
  defaultVariants: {
    state: 'open',
  },
})

const openIconVariants = cva('h-5 w-6', {
  variants: {
    state: {
      open: 'fill-white',
      exceedsThreshold: 'fill-white',
      pause: 'fill-gray-400 group-hover:fill-green-400',
    },
  },
  defaultVariants: {
    state: 'open',
  },
})

const closeIconVariants = cva('h-5 w-6', {
  variants: {
    state: {
      open: 'group-hover:fill-orange-400',
      exceedsThreshold: 'group-hover:fill-orange-400',
      pause: '',
    },
  },
  defaultVariants: {
    state: 'open',
  },
})

export interface MobileRequestToggleProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof mobileRequestToggleVariants> {}

export const MobileRequestToggle = React.forwardRef<HTMLButtonElement, MobileRequestToggleProps>(
  ({ className, state, ...props }, ref) => (
    <button type="button" className={cn(mobileRequestToggleVariants({ state, className }))} ref={ref} {...props}>
      <div className={cn(openButtonVariants({ state }))}>
        <Icons.checkCircle className={cn(openIconVariants({ state }))} />
      </div>
      <div className={cn(closeButtonVariants({ state }))}>
        <Icons.stopCircle className={cn(closeIconVariants({ state }))} />
      </div>
    </button>
  )
)
